import { useQuery } from "@apollo/client";
import type { GoogleBusinessInsightsQuery } from "@/gql/graphql";
import { GOOGLE_BUSINESS_INSIGHTS_QUERY } from "@/graphql/google-business";
import { useSalonStore } from "@/lib/store/salon";

export type GbpInsights = GoogleBusinessInsightsQuery["googleBusinessInsights"];

export function useGbpInsights() {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id;

  const { data, loading } = useQuery(GOOGLE_BUSINESS_INSIGHTS_QUERY, {
    variables: { salonId: salonId ?? "" },
    skip: !salonId,
    // Silently swallow errors — salon may not have a GBP connection yet.
    errorPolicy: "ignore",
    fetchPolicy: "cache-and-network",
  });

  return {
    insights: data?.googleBusinessInsights ?? null,
    loading,
  };
}
